var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ArrowBackIcon as HeaderBackIcon } from '../../Icon';
import Button from '../../Button';
import './HeaderBack.scss';
export var HeaderBackPropTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
};
export var HeaderBackDefaultProps = {
    ariaLabel: 'Back to previous screen',
};
// TODO: Fix me, if we dont need state and we dont need handleOnClick convert me to a simple function
var HeaderBack = /** @class */ (function (_super) {
    __extends(HeaderBack, _super);
    function HeaderBack(props) {
        var _this = _super.call(this, props) || this;
        // TODO: Fix me, we dont need this extra handleOnClick
        _this.handleOnClick = function (e) {
            _this.props.onClick(e);
        };
        // TODO: Fix me, please remove this state if we dont need it
        _this.state = {
            isMinimized: false,
        };
        return _this;
    }
    // TODO: Fix me, if posible please remove {' '} */
    HeaderBack.prototype.render = function () {
        var _a = this.props, title = _a.title, ariaLabel = _a.ariaLabel, id = _a.id;
        return (React.createElement("div", { className: "elmo-header__back-btn-wrapper" },
            React.createElement(Button, __assign({}, (id ? { id: id } : null), { isText: true, onClick: this.handleOnClick, icon: React.createElement(HeaderBackIcon, null), ariaLabel: ariaLabel }),
                ' ',
                title)));
    };
    HeaderBack.defaultProps = HeaderBackDefaultProps;
    return HeaderBack;
}(Component));
export default HeaderBack;
